import { createSelectors } from "../helpers";
import { useMenuDrawerStore } from "./store";

export const useMenuDrawerStoreSelectors = createSelectors(useMenuDrawerStore);
